import React from "react";
import { Avatar, Dialog, DialogTitle, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from "@mui/material";
import { blue } from "@mui/material/colors";
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import AddIcon from '@mui/icons-material/Add';
import { ImageSize } from "./GalleryItemModal";



export function SizeDialog(props) {
  const { onClose, selectedValue, open, sizeOptions } = props;

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleListItemClick = (value) => {
    let choosenSize: ImageSize;
    if (value === "addCustomSize")
      choosenSize = {
        name: 'Custom',
        option: 'custom',
        resolution: [100, 100]
      };

    else
      choosenSize = value;
    onClose(choosenSize);
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>Choose Image Size</DialogTitle>
      <List sx={{ pt: 0 }}>
        {sizeOptions.map((size, key) => (
          <ListItem disableGutters key={key}>
            <ListItemButton onClick={() => handleListItemClick(size)} key={size.option}>
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: blue[100], color: blue[600] }}>
                  <AspectRatioIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={size.name} />
            </ListItemButton>
          </ListItem>
        ))}

        <ListItem disableGutters>
          <ListItemButton
            autoFocus
            onClick={() => handleListItemClick('addCustomSize')}
          >
            <ListItemAvatar>
              <Avatar>
                <AddIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary="Add Custom Size" />
          </ListItemButton>
        </ListItem>
      </List>
    </Dialog>
  );
}
